export default

    class WalletController {

    constructor(resource) {
        this._resource = resource
    }

    async get(){
        return this._resource(`wallet`)
            .get()
            .then( res => res.body)
            .catch( error => { throw error})
    }

    async getSaldoDisponivelByUser(){
        return this._resource('wallet/saldoDisponivel')
            .get()
            .then( res => res.body)
            .catch( error => { throw error})
    }

    async deposit(card, dataAuth, valor, payment_method = 'debit'){
        return await this._resource('wallet/deposit')
            .update({
                card, dataAuth, valor, payment_method
            })
            .then( res => {
                return res.body    
            }, error => { throw error })
    }     
}